const BASE = '/';

function getToken() {
  return localStorage.getItem('token');
}

async function request(path, options = {}) {
  const token = getToken();
  const res = await fetch(BASE + path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.erro || 'Erro na requisição');
  return data;
}

export const api = {
  login: (email, senha) => request('auth/login', { method: 'POST', body: JSON.stringify({ email, senha }) }),
  register: (nome, email, senha) => request('auth/register', { method: 'POST', body: JSON.stringify({ nome, email, senha }) }),
  listarClientes: (busca) => request(`clientes${busca ? `?busca=${encodeURIComponent(busca)}` : ''}`),
  buscarCliente: (id) => request(`clientes/${id}`),
  criarCliente: (dados) => request('clientes', { method: 'POST', body: JSON.stringify(dados) }),
  atualizarCliente: (id, dados) => request(`clientes/${id}`, { method: 'PUT', body: JSON.stringify(dados) }),
  deletarCliente: (id, opts = {}) => request(`clientes/${id}${opts.excluirFinanceiro ? '?financeiro=excluir' : ''}`, { method: 'DELETE' }),
};
